import emailjs from 'emailjs-com';
import React, { useState } from 'react';
import './Contact.css';

const Contact = () => {
  const [loading, setLoading] = useState(false);
  const [consent, setConsent] = useState(false);

  const sendEmail = (e) => {
    e.preventDefault();
    if (!consent) {
      alert('Please agree to receive text messages.');
      return;
    }
    setLoading(true);
    emailjs
      .sendForm('service_r0plfhi', 'template_u09h6hd', e.target, 'user_kftkAVN4w3dLOjj83aAtF')
      .then(
        (result) => {
          console.log(result.text);
          e.target.reset();
          setConsent(false);
          alert('Message sent successfully!');
        },
        (error) => {
          console.log(error.text);
          alert('Failed to send message.');
        }
      )
      .finally(() => setLoading(false));
  };

  return (
    <section id="Contact" className="contact-section">
      <div className="contact-wrapper">
        
        {/* Left Side - Contact Info */}
        <div className="contact-info-box">
          <h2 className="info-title">Contact Us</h2>
          <p className="info-subtitle">
            Have a question or need assistance? Send us a message and we’ll get back to you within 24 hours.
          </p>

          <div className="info-details">
            <p><i className="fa-solid fa-location-dot"></i> 505 E Huntland Dr, Austin, TX 78752 <br></br>
            Florida – Regional Office <br></br>
Missouri – Regional Office <br></br>
Kentucky – Regional Office <br></br>
North Carolina – Regional Office</p>
            <p><i className="fa-solid fa-phone"></i> (737) 377-1728</p>
            <p><i className="fa-solid fa-envelope"></i> vendor@xevenmaintenance.com</p>
          </div>

          <div className="social-section">
            <h4>Follow Us</h4>
            <div className="social-icons">
              <a href="#" target="_blank" rel="noopener noreferrer"><i className="fa-brands fa-facebook-f"></i></a>
              <a href="#" target="_blank" rel="noopener noreferrer"><i className="fa-brands fa-linkedin-in"></i></a>
              <a href="#" target="_blank" rel="noopener noreferrer"><i className="fa-brands fa-instagram"></i></a>
            </div>
          </div>

          <div className="payment-methods">
            <h4>Payment Partners</h4>
            <div className="payment-icons">
              <i className="fab fa-cc-visa fa-2x" title="Visa"></i>
              <i className="fab fa-cc-mastercard fa-2x" title="MasterCard"></i>
              <i className="fab fa-cc-stripe fa-2x" title="Stripe"></i>
              <i className="fab fa-cc-paypal fa-2x" title="PayPal"></i>
            </div>
          </div>
        </div>

        {/* Right Side - Form */}
        <div className="contact-form-box">
          <h2 className="form-title">Get In Touch</h2>
          <form onSubmit={sendEmail} className="contact-form">
            <div className="row">
              <input type="text" name="first_name" placeholder="First Name" required />
              <input type="text" name="last_name" placeholder="Last Name" required />
            
            <input type="text" name="company" placeholder="Company" />
            <input type="email" name="email" placeholder="Email" required />
            <input type="tel" name="phone" placeholder="Phone Number" required />
            <textarea name="message" rows="5" placeholder="Message" required />
            </div>

            <div className="consent">
              <input
                type="checkbox"
                id="consent"
                checked={consent}
                onChange={() => setConsent(!consent)}
              />
              <label htmlFor="consent">
                I agree to receive text messages (SMS) from Zeven Home Solutions LLC at the phone number
                provided. I understand consent is not a condition of purchase. Reply STOP to
                cancel, HELP for help. See our <a href="/privacypolicy.html" target="_blank" rel="noopener noreferrer">Privacy Policy</a>, <a href="/privacy.html" target="_blank" rel="noopener noreferrer">Terms & Conditions</a>, and <a href="/refund.html" target="_blank" rel="noopener noreferrer">Refund Policy</a>.
              </label>
            </div>

            <button type="submit" disabled={loading}>
              {loading ? 'Sending…' : "Let's Talk"}
            </button>
          </form>
        </div>
      </div>
    </section>
  );
};

export default Contact;
